import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { useSubscription } from '../../context/SubscriptionContext';
import { useI18n } from '../../i18n';

const DISMISS_KEY = 'domio_trial_banner_dismissed';

function formatTrialEnd(iso, locale) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString(locale, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return iso;
  }
}

export default function TrialBanner() {
  const { t, language } = useI18n();
  const { isTrialing, trialEndsAt } = useSubscription();
  const [dismissed, setDismissed] = useState(
    () => typeof sessionStorage !== 'undefined' && sessionStorage.getItem(DISMISS_KEY) === '1',
  );

  if (!isTrialing || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  const locale = language === 'es' ? 'es' : 'en-US';
  const dateStr = formatTrialEnd(trialEndsAt, locale);

  return (
    <div
      className="bg-gradient-to-r from-domio-700 to-domio-600 text-white px-4 sm:px-6 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3 text-sm"
      data-testid="trial-banner"
    >
      <div className="flex items-start sm:items-center gap-2 min-w-0 flex-1">
        <Sparkles className="h-4 w-4 shrink-0 mt-0.5 sm:mt-0" />
        <p className="leading-snug break-words">
          {t('pricing.trial.message', { date: dateStr })}
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0 self-end sm:self-auto">
        <Button asChild size="sm" variant="secondary" className="h-8 bg-white/20 hover:bg-white/30 text-white border-0">
          <Link to="/app/pricing">{t('pricing.trial.upgrade')}</Link>
        </Button>
        <button
          type="button"
          onClick={dismiss}
          className="p-1 rounded hover:bg-white/20"
          aria-label={t('pricing.trial.dismiss')}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
